export const mobActivityCategories = [
  {
    label: 'Treatment',
    value: 'treatment',
  },
  {
    label: 'Feeding',
    value: 'feeding',
  },
  {
    label: 'Joining',
    value: 'joining',
  },
  {
    label: 'Marking',
    value: 'marking',
  },
  {
    label: 'Crutching',
    value: 'crutching',
  },
  {
    label: 'Shearing',
    value: 'shearing'
  },
  {
    label: 'Death',
    value: 'death',
  },
  {
    label: 'Sale',
    value: 'sale',
  },
  {
    label: 'Other',
    value: 'other',
  },
]